module.exports = __webpack_public_path__ + "static/media/twitterbannertablet.45608106.png";